export const STATUS_CHIP_VARIANTS = {
  NAVY: "navy",
  BLUE: "blue",
  BLUE_TINT: "blue-tint",
  AMBER: "amber",
  NEUTRAL: "neutral",
  RED: "red",
} as const;
